<template>
  <div class="checks-card">
    <div class="checks-card__head">
      <div class="checks-card__title">{{ $t('unpassedCheck') }}</div>
      <div
        v-if="canSee"
        class="checks-card__toggle"
      >
        <button
          type="button"
          class="checks-card__tab"
          :class="{ 'is-active': checkType === 'payCheck' }"
          @click="toggleCheck('payCheck')"
        >
          {{ $t('checkPayableShort') }}
        </button>
        <button
          type="button"
          class="checks-card__tab"
          :class="{ 'is-active': checkType === 'recieveCheck' }"
          @click="toggleCheck('recieveCheck')"
        >
          {{ $t('checkReceivableShort') }}
        </button>
      </div>
      <div
        v-if="canSee && total != null"
        class="checks-card__count"
      >
        {{ total }} {{ $t('check') }}
      </div>
    </div>

    <div
      v-if="canSee"
      ref="scrollContainer"
      class="checks-card__list"
    >
      <div
        v-for="item in items"
        :key="item.id || item.number"
        class="checks-card__row"
      >
        <span class="checks-card__meta">
          <span>{{ $t('check') }} {{ item.number || '—' }}</span>
          <span
            v-if="bankName(item)"
            class="checks-card__dot"
          >·</span>
          <span v-if="bankName(item)">{{ bankName(item) }}</span>
          <span
            v-if="dueLabel(item)"
            class="checks-card__dot"
          >·</span>
          <span v-if="dueLabel(item)">{{ dueLabel(item) }}</span>
        </span>
        <span class="checks-card__amount">
          {{ $numberFormat(item.amount) }}
          {{ $store.state.currency.name }}
        </span>
      </div>
      <div
        v-if="!loading && !items.length"
        class="checks-card__empty"
      >
        {{ $t('there is no enough information for showing.') }}
      </div>
      <div
        v-if="loading || loadingPaginate"
        class="checks-card__more"
      >
        <v-progress-circular
          :width="3"
          color="blue"
          indeterminate
          size="22"
        />
      </div>
    </div>
    <div
      v-else
      class="checks-card__empty"
    >
      {{ $t("you don't have access to this information") }}
    </div>
    <button
      v-if="canSee"
      type="button"
      class="checks-card__all"
      @click="goto"
    >
      {{ $t('viewAll') }}
    </button>
  </div>
</template>

<script>
import moment from 'moment-jalaali'

moment.loadPersian({ dialect: 'persian-modern', usePersianDigits: false })

export default {
  data () {
    return {
      items: [],
      loading: false,
      loadingPaginate: false,
      page: 1,
      lastPage: 1,
      checkType: 'payCheck',
      status: 'issued',
      total: null
    }
  },
  computed: {
    canSee () {
      return this.$store.getters.getpermission && this.$store.getters.getpermission.includes('overview')
    }
  },
  mounted () {
    this.fetchList()
    this.$nextTick(() => {
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.addEventListener('scroll', this.handleScroll)
      }
    })
  },
  beforeDestroy () {
    if (this.$refs.scrollContainer) {
      this.$refs.scrollContainer.removeEventListener('scroll', this.handleScroll)
    }
  },
  methods: {
    bankName (item) {
      const name = (item.bank && item.bank.name) || item.bank_name || ''
      if (!name) return ''
      if (String(name).trim().indexOf(this.$t('bank')) === 0) return name
      return this.$t('bank') + ' ' + name
    },
    dueLabel (item) {
      if (!item.due_date) return ''
      const due = moment(item.due_date, 'jYYYY/jMM/jDD')
      if (!due.isValid()) return this.$t('due') + ' ' + item.due_date
      return this.$t('due') + ' ' + due.format('jD jMMMM')
    },
    fetchList () {
      if (!this.items.length) this.loading = true
      this.$axios.get(this.$endpoint + 'checks', {
        params: {
          page: this.page,
          options: JSON.stringify({
            page: this.page,
            itemsPerPage: 20
          }),
          type: this.checkType,
          status: [this.status]
        }
      }).then(r => {
        const rows = r.data.data || []
        this.items = this.items.concat(rows)
        this.lastPage = r.data.last_page || 1
        this.total = r.data.total != null ? r.data.total : this.items.length
      }).catch(() => {
        if (!this.items.length) this.items = []
      }).finally(() => {
        this.loading = false
        this.loadingPaginate = false
      })
    },
    handleScroll () {
      const container = this.$refs.scrollContainer
      if (!container || this.loadingPaginate || this.loading) return
      if (container.scrollTop + container.clientHeight >= container.scrollHeight - 8) {
        if (this.page < this.lastPage) {
          this.loadingPaginate = true
          this.page += 1
          this.fetchList()
        }
      }
    },
    toggleCheck (value) {
      if (this.checkType === value) return
      this.checkType = value
      this.status = value === 'payCheck' ? 'issued' : 'fund'
      this.page = 1
      this.lastPage = 1
      this.items = []
      this.total = null
      this.fetchList()
    },
    goto () {
      if (this.checkType === 'payCheck') {
        this.$router.push('/check/pay/list').catch(() => {})
      } else {
        this.$router.push('/check/recieve/list').catch(() => {})
      }
    }
  }
}
</script>

<style scoped>
.checks-card {
  background: #fff;
  border: 1px solid #E5E7EB;
  border-radius: 4px;
  padding: 12px 14px;
  height: 262px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.checks-card__head {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 28px;
  margin-bottom: 8px;
  flex-shrink: 0;
}
.checks-card__title {
  font-size: 13px;
  font-weight: 700;
  color: #111;
  white-space: nowrap;
}
.checks-card__count {
  margin-inline-start: auto;
  font-size: 12px;
  color: #6B7280;
  white-space: nowrap;
}
.checks-card__toggle {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.checks-card__tab {
  height: 28px;
  padding: 0 12px;
  border: 1px solid #E5E7EB;
  background: #fff;
  border-radius: 4px;
  font-size: 12px;
  color: #111;
  cursor: pointer;
}
.checks-card__tab.is-active {
  background: #0066FF;
  border-color: #0066FF;
  color: #fff;
}
.checks-card__all {
  flex-shrink: 0;
  width: 100%;
  height: 34px;
  margin-top: 8px;
  border: none;
  background: none;
  color: #0066FF;
  font-size: 12px;
  cursor: pointer;
  padding: 0;
}
.checks-card__list {
  height: 160px;
  flex: none;
  overflow-y: auto;
}
.checks-card__list::-webkit-scrollbar {
  width: 4px;
}
.checks-card__list::-webkit-scrollbar-thumb {
  background: #D1D5DB;
  border-radius: 4px;
}
.checks-card__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  height: 40px;
  padding: 0;
  border-bottom: 1px solid #F3F4F6;
}
.checks-card__row:last-child {
  border-bottom: none;
}
.checks-card__meta {
  min-width: 0;
  font-size: 12px;
  color: #111;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
.checks-card__dot {
  color: #9CA3AF;
}
.checks-card__amount {
  flex-shrink: 0;
  font-size: 12px;
  color: #111;
  white-space: nowrap;
}
.checks-card__empty {
  flex: 1;
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #6B7280;
  text-align: center;
}
.checks-card__more {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
}
</style>
